export enum StakeState {
	UNKNOWN,
	APPROVE,
	APPROVING,
	WRAP,
	WRAPPING,
	STAKE,
	STAKING,
	UNSTAKE,
	UNSTAKING,
	CONFIRM_UNSTAKE,
	CONFIRMING,
	CONFIRMED,
	REJECT,
	SUBMITTING,
	ERROR,
}
